import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as Layout from '@zocdoc/components/src/Layout';
import breakpoint from '@zocdoc/components/src/grid/mixins/breakpoint';
import * as colors from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc/components/src/typography';
import docSVG from './doc.svg';

class SalpBlock extends Component {
    static propTypes = {
        block: PropTypes.shape({
            section1: PropTypes.string.isRequired,
            section2: PropTypes.string.isRequired,
            section3: PropTypes.string,
        }).isRequired,
    };

    render() {
        const { toHtml } = this;
        const { block } = this.props;
        return (
            <StyledBlockContainer data-test={this.props['data-test']}>
                <StyledSection1 dangerouslySetInnerHTML={toHtml(block.section1)} />
                <StyledSection2 dangerouslySetInnerHTML={toHtml(block.section2)} />
                {block.section3 && (
                    <StyledSection3 dangerouslySetInnerHTML={toHtml(block.section3)} />
                )}
            </StyledBlockContainer>
        );
    }

    toHtml(markup) {
        return {
            __html: markup,
        };
    }
}

const PaddedContainerBase = styled(Layout.PaddedContainer)`
    padding-top: 15px;
    padding-bottom: 15px;
    width: 100%;
    
    ${breakpoint.small} {
        padding-top: 30px;
        padding-bottom: 30px;
    }
`;


const StyledBlockContainer = styled.div`
    display: flex;
    align-items: stretch;
    flex-flow: row wrap;
    
    a {
        color: ${colors.blueLink};
    }
    
    p {
        font: 14px/20px ${FontFamily.KievitSlabBook};
    }
    
    b, strong {
        font: 14px/20px ${FontFamily.SharpSansBold};
    }
    
    h1, h2, h3 {
        font-family: ${FontFamily.SharpSansBold};
        margin-bottom: 11px;
    }
    
    h1 {
        font-size: 32px;
        line-height: 40px;
    }
    
    h2 {
        font-size: 24px;
        line-height: 30px;
    }
    
    h3 {
        font-size: 18px;
        line-height: 24px;
    }
    
    ul, ol {
        font: 14px/20px ${FontFamily.KievitSlabBook};
        padding: 15px 30px;
    }
    
    ul {
        list-style: disc outside none;
    }
    
    ol {
        list-style: decimal outside none;
    }
    
    div.zd_salp_responsive_columns {
        box-sizing: border-box;
        display: flex;
        align-items: stretch;
        flex-flow: row wrap;
        div.zd_salp_col_50 {
            width: 100%;
            padding-right: 15px;
            ${breakpoint.small} {
                width: 50%;
                padding-right: 35px;
            }
        }
    }
`;

const StyledSection1 = styled(PaddedContainerBase)`
    width: 100%;
    background-color: ${colors.white};
    ${breakpoint.small} {
        width: 50%;
    }
`;

const StyledSection2 = styled(PaddedContainerBase)`
    width: 100%;
    background: ${colors.navy} url('${docSVG}') no-repeat right 25px bottom;
    background-size: 90px;
    padding-bottom: 100px;
    padding-right: 120px;
    min-height: 230px;
    color: ${colors.grey10};
    ${breakpoint.small} {
        width: 50%;
    }
`;

const StyledSection3 = styled(PaddedContainerBase)``;

export default SalpBlock;
